<template>
	<div>
		<!-- 搜索条件区域 -->
		<div class="search-container">
			<div class="search-form">
				<div class="form-item">
					<span class="label">项目名称</span>
					<el-input v-model="queryParams.projectName" placeholder="请输入项目名称" clearable></el-input>
				</div>
				<div class="form-item">
					<span class="label">建设单位</span>
					<el-input v-model="queryParams.constructionUnit" placeholder="请输入建设单位名称" clearable></el-input>
				</div>
				<div class="form-buttons">
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="handleResetSearch">重置</el-button>
					<el-button :disabled="multiple" type="primary" plain @click="handleRemoveAllCollect">
						批量取消收藏
					</el-button>
				</div>
			</div>
		</div>

		<!-- 列表区域 -->
		<data-table
			:table-data="useCollectProjectList"
			:column="columns"
			:page-options="pageOptions"
			:border="true"
			:loading="loading"
			:selection="true"
			:reserve-selection="true"
			:row-keys="handleRowKeys"
			@selectionChange="handleSelectDataChange"
			@page-change="handlePaginationChange"
		>
			<template slot="tools" slot-scope="data">
				<el-button @click="handleRemoveCollect(data.scope.row)">取消收藏</el-button>
				<el-button @click="handleLookDetail(data.scope.row)">查看详情</el-button>
			</template>
		</data-table>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { pageUserCollectProject, removeUserCollect } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum'

	// 用户收藏的资质查-项目信息
	export default {
		name: 'CollectProject',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				queryParams: {
					projectName: '',
					constructionUnit: ''
				},
				columns: [
					{ label: '项目名称', prop: 'projectName', align: 'center' },
					{ label: '建设单位', prop: 'constructionUnit', align: 'center' },
					{ label: '收藏日期', prop: 'collectTime', width: '180', align: 'center' },
					{ label: '操作', prop: '', align: 'center', width: '280', slot: 'tools' }
				],
				// 用户收藏的资质查- 项目信息
				useCollectProjectList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 非多个禁用
				multiple: true,
				// 选中的id集合
				selectIds: []
			}
		},
		computed: {},
		watch: {},
		created() {
			this.getUserCollectProjectList()
		},
		mounted() {},
		methods: {
			// 查询用户收藏的项目信息
			getUserCollectProjectList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				pageUserCollectProject(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							// 添加选择状态字段
							this.useCollectProjectList = data.records.map(item => ({
								...item,
								selected: false
							}))
							this.pageOptions.total = data.total || 0
						} else {
							this.useCollectProjectList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.useCollectProjectList = []
						this.pageOptions.total = 0
					})
			},

			handleRowKeys(row) {
				return row.id
			},

			// 选中回调
			handleSelectDataChange(selection) {
				this.selectIds = selection.map(item => item.id)
				this.multiple = !selection.length
			},

			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getUserCollectProjectList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.getUserCollectProjectList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					projectName: '',
					constructionUnit: ''
				}
				this.getUserCollectProjectList()
			},

			// 用户取消收藏
			handleRemoveCollect(item) {
				const data = {
					collectType: COLLECT_TYPE_STATE.PROJECT,
					collectIds: [item.id]
				}
				removeUserCollect(data).then(response => {
					this.getUserCollectProjectList()
				})
			},

			// 批量取消收藏
			handleRemoveAllCollect() {
				const selectedIds = this.selectIds

				const data = {
					collectType: COLLECT_TYPE_STATE.PROJECT,
					collectIds: selectedIds
				}

				removeUserCollect(data).then(response => {
					this.getUserCollectProjectList()
				})
			},
			// 查看详情
			handleLookDetail(item) {
				this.$router.push({
					path: '/qualification-query/projectDetail',
					query: {
						id: item.id // 传递详情ID参数
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.table-list-container {
		.table-header {
			.header-item {
				&:last-of-type {
					flex: 0 0 226px;
				}
			}
		}
	}
</style>
